import React from 'react';
import {
  useSelector,
} from 'react-redux';
import MeNowModal from '../me-now-modal';
import { UnreachableError } from 'hellospa/ts-utils';
import Button, { ButtonType } from 'hellospa/foundation/control/button';
import * as selectors from 'hellospa/page/prep-and-send/data/selectors';
import * as types from 'hellospa/page/prep-and-send/data/types';
import { useIntl } from 'react-intl';

import styles from '../index.scss';
import messages from '../intl';
import { trackHeapCustomEvent } from 'common/utils/heap';

type MeOnlyProps = {
  recipients: types.Recipient[],
  handleClick: () => unknown
}
const MeOnlyCta = ({ handleClick, recipients }: MeOnlyProps) => {
  const intl = useIntl();
  const workflow = useSelector(selectors.getWorkflow);
  const [isModalOpen, setModalOpen] = React.useState(false);
  const allowMeOnlyAsSigner = useSelector(selectors.allowMeOnlyAsSigner);
  const isDocToTemplateChecked = useSelector(selectors.shouldConvertDocToTemplate);
  const isDeepIntegration = useSelector(selectors.isDeepIntegration);

  if (!workflow.tags.includes(types.WorkflowTags.SignatureRequestDocument)) {
    return null;
  }

  const saveMeOnly = async () => {
    handleClick();
  };

  const handleMeOnly = async () => {
    if (isDocToTemplateChecked) {
      trackHeapCustomEvent('doc_to_template_v2_upload_banner_self_sign_checked');
    }
    const filteredRecipients = recipients.filter((r) => {
      switch (r.type) {
        case types.RecipientTypes.Signer: {
          // Filter out empty signers
          return r.name !== '' && r.email !== '';
        }
        case types.RecipientTypes.Role:
        case types.RecipientTypes.Fax:
          // These types aren't really relevant in a flow that could be me-only,
          // but they still need to be handled.
          return true;
        default: throw new UnreachableError(r);
      }
    });

    if (filteredRecipients.length === 0) {
      await saveMeOnly();
    } else {
      setModalOpen(true);
    }
  };

  if (!allowMeOnlyAsSigner) {
    return null;
  }

  return (
    <div className={styles.meOnlyCtaContainer}>
      <MeNowModal
        isOpen={isModalOpen}
        onConfirm={saveMeOnly}
        onCancel={() => setModalOpen(false)}
        confirmButtonType={isDeepIntegration ? ButtonType.Primary : undefined} />
      <Button
        type="button"
        kind={ButtonType.Link}
        className={styles.meOnlyCta}
        onClick={handleMeOnly}
        data-qa-ref="recipients.buttons.me_now"
      >
        {intl.formatMessage(messages.meNowSignerButton)}
      </Button>
    </div>
  );
};

export default MeOnlyCta;
